import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";
import "./oia-risco-banner.container.css";
import { Container } from "../../components/container/container";

type OiaRiscoBannerProps = {
  url: string;
};

const FEATURES = [
  "Registre eventos climáticos e outras ocorrências",
  "Envie fotos e vídeos como evidências",
  "Consulte os registros diretamente no mapa",
] as const;

export function OiaRiscoBanner({ url }: OiaRiscoBannerProps) {
  return (
    <div className="xvia-oia-risco-banner__container">
      <Container>
        <section
          className="xvia-oia-risco-banner"
          aria-label="Óia o Risco — Defesa Civil do Piauí"
        >
          <div className="xvia-oia-risco-banner__content">
            <div className="xvia-oia-risco-banner__content-left">
              <h2 className="xvia-oia-risco-banner__title">Óia o Risco!</h2>
              <p className="xvia-oia-risco-banner__content-text">
                Plataforma da Defesa Civil para registro e monitoramento de
                eventos climáticos e situações de risco no Piauí.
              </p>
              <ul className="xvia-oia-risco-banner__list">
                {FEATURES.map((feature) => (
                  <li key={feature}>{feature}</li>
                ))}
              </ul>
            </div>
            <div
              className="xvia-oia-risco-banner__content-right"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/pngs/oia-risco-logo.png)`,
              }}
              role="img"
              aria-label="Logo Óia o Risco"
            />
            <Button
              endIcon={<OpenInNewIcon style={{ fontSize: 20 }} />}
              variant="contained"
              size="small"
              className="xvia-oia-risco-banner__content-button"
              href={url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Acesse agora
            </Button>
          </div>
        </section>
      </Container>
    </div>
  );
}
